import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  Col,
} from 'reactstrap';

import { BtnOutlineGreen } from '../../styled-components';
import _ from 'lodash';
import { getValidationErrorMessage } from './helpers';
import ExportCSVRow from './ExportCSVRow';
import contractsAPIs from '../../lib/fetch/contractsAPIs';
import { useAuth } from '../../commons/Auth';

function ContractsImportFeedbackModal({ toggle, isOpen, data = {} }) {
  const [t] = useTranslation('CONTRACTS');
  const [{ newToken } = {}] = useAuth();
  const [totContractValues, setTotContractValues] = useState(0);

  const {
    errors = {},
    validationErrors: topValidationErrors,
    updatedContracts = [],
  } = data;
  let validationErrors = false;
  if (topValidationErrors && Array.isArray(topValidationErrors.message)) {
    validationErrors = topValidationErrors.message;
  }
  if (
    topValidationErrors &&
    topValidationErrors.message &&
    !Array.isArray(topValidationErrors.message)
  ) {
    validationErrors = [topValidationErrors.message];
  }

  useEffect(() => {
    if (isOpen && updatedContracts.length > 0) {
      const fetchContracts = async (query) => {
        const { data } = await contractsAPIs.findForTotImport({
          newToken,
          query,
        });
        setTotContractValues(data || 0);
      };

      fetchContracts({
        pod_pdr: [...updatedContracts].map((c) => c.pod_pdr),
      });
    }
  }, [data]);

  const {
    contractMalformed = [],
    contractsNotInsertedError = [],
    clientsNotFound = [],
    suppliersNotFound = [],
    nonCompliantProducts = [],
    nonCompliantProductsAdmin = [],
    contractsWithNoSupplier = [],
    nonCompliantCustomerAdmin = [],
    contractsActivationDateTooFar = [],
    contractWithSameSupplier = [],
    errorsHistoryStartDate = [],
    errorsRecurringStartDate = [],
    errorsContractEndDate = [],
    errorsDuplicateFee = [],
  } = errors;

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>
        {validationErrors
          ? t('MALFORMED_FILE')
          : t('IMPORTED_CONTRACTS_FEEDBACK')}
      </ModalHeader>

      {!validationErrors && (
        <ModalBody>
          <Row>
            <Col sm="12">
              <h5>
                {t('UPDATED_CONTRACTS_NUMBER')}: {updatedContracts?.length || 0}
              </h5>
            </Col>
          </Row>
          <Row>
            <Col sm="12">
              <h5>
                {t('TOTAL_NET_CONTRACTS')}: {totContractValues}
              </h5>
            </Col>
          </Row>
          <Row>
            <Col sm="12">
              <h5>
                {t('NOT_INSERTED_CONTRACTS_NUMBER')}:{' '}
                {_.uniqWith(
                  [
                    ...contractsNotInsertedError,
                    ...suppliersNotFound,
                    ...contractMalformed,
                    ...clientsNotFound,
                    ...nonCompliantProducts,
                    ...nonCompliantProductsAdmin,
                    ...nonCompliantCustomerAdmin,
                    ...contractsWithNoSupplier,
                    ...contractsActivationDateTooFar,
                    ...contractWithSameSupplier,
                    ...errorsHistoryStartDate,
                    ...errorsRecurringStartDate,
                    ...errorsContractEndDate,
                    ...errorsDuplicateFee,
                  ],
                  _.isEqual
                ).length || 0}
              </h5>
              <ul>
                <ExportCSVRow
                  data={contractsNotInsertedError}
                  text={t('CONTRACTS_NOT_INSERTED')}
                />
                <ExportCSVRow
                  data={suppliersNotFound}
                  text={t('SUPPLIERS_NOT_FOUND')}
                />
                <ExportCSVRow
                  data={clientsNotFound}
                  text={t('CLIENTS_NOT_FOUND')}
                />
                <ExportCSVRow
                  data={contractMalformed}
                  text={t('MALFORMED_CONTRACTS')}
                />
                <ExportCSVRow
                  data={nonCompliantProducts}
                  text={t('NON_COMPLIANT_CONTRACTS')}
                />
                <ExportCSVRow
                  data={nonCompliantProductsAdmin}
                  text={t('NON_COMPLIANT_CONTRACTS_ADMIN')}
                />
                <ExportCSVRow
                  data={nonCompliantCustomerAdmin}
                  text={t('NOT_COMPLIANT_CUSTOMER_ADMIN')}
                />
                <ExportCSVRow
                  data={contractsWithNoSupplier}
                  text={t('CONTRACTS_WITH_NO_SUPPLIER')}
                />
                <ExportCSVRow
                  data={contractWithSameSupplier}
                  text={t('SAME_SUPPLIER_CONTRACTS')}
                />
                <ExportCSVRow
                  data={contractsActivationDateTooFar}
                  text={t('ACTIVATION_DATE_TOO_FAR')}
                />
                <ExportCSVRow
                  data={errorsHistoryStartDate}
                  text={t('ERRORS_HISTORY_START_DATE')}
                />
                <ExportCSVRow
                  data={errorsRecurringStartDate}
                  text={t('ERRORS_RECURRING_START_DATE')}
                />
                <ExportCSVRow
                  data={errorsContractEndDate}
                  text={t('ERRORS_CONTRACT_END_DATE')}
                />
                <ExportCSVRow
                  data={errorsDuplicateFee}
                  text={t('ERRORS_DUPLICATE_FEE')}
                />
              </ul>
            </Col>
          </Row>
        </ModalBody>
      )}
      {validationErrors && (
        <ModalBody>
          <Row>
            <Col sm="12">
              {validationErrors.map((v) => (
                <h5>{getValidationErrorMessage({ message: v })}</h5>
              ))}
            </Col>
          </Row>
        </ModalBody>
      )}
      <ModalFooter>
        <BtnOutlineGreen type="button" className="uppercase" onClick={toggle}>
          {t('COMMON:CLOSE')}
        </BtnOutlineGreen>
      </ModalFooter>
    </Modal>
  );
}

export default ContractsImportFeedbackModal;
